import script from "./EditViolator.vue?vue&type=script&setup=true&lang=js"
export * from "./EditViolator.vue?vue&type=script&setup=true&lang=js"

import "./EditViolator.vue?vue&type=style&index=0&id=07e33604&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e33604"]])

export default __exports__